import { Box, Button, Center, Divider, Text, VStack } from "@chakra-ui/react";
import { SPACING } from "../constants/Constants";
import { FaGhost, FaHome } from "react-icons/fa";

export default function NotFound() {
    return (
        <Box textAlign="center" fontSize="xl">
            <Center p={"10vw"}>
                <VStack>
                    <FaGhost size="10vh" />
                    <Divider my={SPACING / 2} />
                    <Text fontSize={"x-large"} fontWeight={"bold"}>
                        404 - Not Found
                    </Text>
                    <Text>
                        The page you are looking for could not be found. It might have been removed, had its name changed or is temporarily unavailable.
                    </Text>
                    <Text fontStyle="italic" mt={SPACING / 2}>
                        If you believe this is an error, please let us know.
                    </Text>
                    <Divider my={SPACING / 2} />
                    <Button colorScheme="teal" onClick={() => window.location.href = "/"}>Back to home &nbsp;<FaHome /></Button>
                </VStack>
            </Center>
        </Box >
    )
};